import React, { Fragment, useState, useRef, useEffect } from "react";
import { Table, Pagination } from "react-bootstrap";

import { Link, useHistory } from "react-router-dom";
import data from "../table/tableData.js";
import Cookies from "universal-cookie";
import { getPostsTable } from "../../../apis/TableData";
import config from "../../../config.js";
import ReactPaginate from "react-paginate";

const UsersTable = () => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const history = useHistory();
  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [postID, setPostID] = useState("");
  const [title, setTitle] = useState("");
  const [postType, setPostType] = useState("");
  const [username, setUsername] = useState("");
  const [pageNo, setPageNo] = useState(0);

  const arr1 = [0, 1, 2];
  const arr2 = [2, 1, 0];

  useEffect(() => {
    if (token === null || token === undefined) {
      history.push("/page-login");
    }
    fetchTableData(0);
  }, []);

  const fetchTableData = (pageNoVar) => {
    getPostsTable(token, postID, username, title, pageNoVar, postType)
      .then((response) => {
        console.log(response);
        if (response.code == 200) {
          setTableData(response.data.data);
          setDataCount(response.data.count);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const resetFilter = (e) => {
    e.preventDefault();
    getPostsTable(token, "", "", "")
      .then((response) => {
        console.log(response);
        if (response.code == 200) {
          setTableData(response.data.data);
          setDataCount(response.data.count);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const queryFilter = (e) => {
    e.preventDefault();
    // console.log(avatar);
    getPostsTable(token, postID, username, title, pageNo, postType)
      .then((response) => {
        console.log(response);
        if (response.code == 200) {
          setTableData(response.data.data);
          setDataCount(response.data.count);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sort = 10;
  let jobPagination = Array(Math.ceil(dataCount / sort))
    .fill()
    .map((_, i) => i + 1);

  const activePag = useRef(0);
  const jobData = useRef(
    data.profileTable.data.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    )
  );
  const [demo, setdemo] = useState();
  const onClick = (i) => {
    console.log("i", i, i.selected);
    activePag.current = i.selected;

    setPageNo(activePag.current);

    jobData.current = data.profileTable.data.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
    setdemo(
      data.profileTable.data.slice(
        activePag.current * sort,
        (activePag.current + 1) * sort
      )
    );

    fetchTableData(activePag.current);
  };

  return (
    <div className="col-12">
      <div className="row">
        <div className="form-group col-md-3">
          <label>Post ID</label>
          <input
            type="text"
            className="form-control"
            onChange={(e) => setPostID(e.target.value)}
          />
        </div>
        <div className="form-group col-md-3">
          <label>Username</label>
          <input
            type="text"
            className="form-control"
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="form-group col-md-3">
          <label>Title</label>
          <input
            type="text"
            className="form-control"
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="form-group col-md-3">
          <label>Post type</label>
          <select
            type="text"
            className="form-control"
            onChange={(e) => setPostType(e.target.value)}
          >
            <option value="">All</option>
            <option value="BLOG">Blog</option>
            <option value="QUESTION">Question</option>
          </select>
        </div>
        {/* <div className="form-group col-md-3">
                      <label>Email</label>
                      <input type="text" className="form-control"/>
            </div> */}
      </div>
      <div className="row mb-3 d-flex justify-content-center">
        <div className="form-group mr-2">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={(e) => queryFilter(e)}
          >
            Submit
          </button>
        </div>
        <div className="form-group ml-2">
          <button
            type="reset"
            className="btn btn-primary"
            onClick={(e) => resetFilter(e)}
          >
            Reset
          </button>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Profile Datatable</h4>
        </div>
        <div className="card-body">
          <Table responsive className="w-100">
            <div id="example_wrapper" className="dataTables_wrapper">
              <table id="example" className="display w-100 dataTable">
                <thead>
                  <tr role="row">
                    {/* {data.profileTable.columns.map((d, i) => (
                                   <th key={i}>{d}</th>
                                ))} */}
                    <th>ID</th>
                    <th>Username</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Likes</th>
                    <th>Replies</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.map((d, i) => (
                    <tr key={i}>
                      <td>{d?.id}</td>
                      <td>{d?.username}</td>
                      <td>
                        <a
                          href={
                            config.mainWebsiteUrl +
                            (d.type === "blog" ? "blogs/" : "questions/") +
                            d?.url
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {d?.url}
                        </a>
                      </td>
                      <td>{d?.type}</td>
                      <td>{d?.status}</td>
                      <td>{d?.reactions}</td>
                      <td>{d?.comments}</td>
                      <td>{d?.created_at}</td>
                      {/* {d.map((da, i) => (
                                      <Fragment key={i}>
                                         <td>
                                            {i === 0 ? (
                                               <img
                                                  className="rounded-circle"
                                                  width="35"
                                                  src={da}
                                                  alt=""
                                               />
                                            ) : (
                                               <Fragment>
                                                  {da}
                                                  {i === 8 && (
                                                     <div className="d-flex">
                                                        <Link
                                                           to="#"
                                                           className="btn btn-primary shadow btn-xs sharp mr-1"
                                                        >
                                                           <i className="fa fa-pencil"></i>
                                                        </Link>
                                                        <Link
                                                           to="#"
                                                           className="btn btn-danger shadow btn-xs sharp"
                                                        >
                                                           <i className="fa fa-trash"></i>
                                                        </Link>
                                                     </div>
                                                  )}
                                               </Fragment>
                                            )}
                                         </td>
                                      </Fragment>
                                   ))} */}
                    </tr>
                  ))}
                </tbody>
                {/* <tfoot>
                             <tr role="row">
                                {data.profileTable.columns.map((d, i) => (
                                   <th key={i}>{d}</th>
                                ))}
                             </tr>
                          </tfoot> */}
              </table>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {activePag.current * sort + 1} to
                  {tableData.length < (activePag.current + 1) * sort
                    ? tableData.length
                    : (activePag.current + 1) * sort}
                  of {dataCount} entries
                </div>

                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next"
                    previousLabel="Previous"
                    pageRangeDisplayed={2}
                    onPageChange={onClick}
                    pageCount={Math.ceil(dataCount / 10)}
                    containerClassName="d-flex p-3 w-full justify-center"
                    pageClassName="px-2 py-1 rounded-md border mr-2  "
                    activeClassName="px-2 py-1 rounded-md mr-2 active-page "
                    previousClassName="px-2 py-1 rounded-md mr-2 bg-white "
                    nextClassName="px-2 py-1 rounded-md border mr-2"
                    breakClassName="px-1 py-1"
                  />

                <div
                  style={{
                    width: "24rem",
                    overflow: "hidden",
                    display: "none",
                  }}
                  className="dataTables_paginate paging_simple_numbers"
                >
                  <Pagination size="lg">
                    <li
                      className="page-item page-indicator "
                      onClick={() =>
                        activePag.current > 0 && onClick(activePag.current - 1)
                      }
                    >
                      {/* <Link className="page-link" to="#">
                                      <i className="la la-angle-left" />
                                   </Link> */}
                      <Link className="paginate_button previous" to="#">
                        {" "}
                        Previous
                      </Link>
                    </li>
                    {jobPagination.map((number, i) => (
                      <Pagination.Item
                        className={activePag.current === i ? "active" : ""}
                        onClick={() => onClick(i)}
                      >
                        {number}
                      </Pagination.Item>
                    ))}
                    {(activePag.current < 3 ||
                      activePag.current > dataCount - 3) && (
                      <>
                        {arr1.map((i) => (
                          <Pagination.Item
                            className={activePag.current === i ? "active" : ""}
                            onClick={() => onClick(i)}
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))}
                        ...
                        {arr2.map((i) => (
                          <Pagination.Item
                            className={
                              activePag.current === dataCount - i
                                ? "active"
                                : ""
                            }
                            onClick={() => onClick(dataCount - i)}
                          >
                            {dataCount - i}
                          </Pagination.Item>
                        ))}
                      </>
                    )}
                    <li
                      className="page-item page-indicator"
                      onClick={() =>
                        activePag.current + 1 < jobPagination.length &&
                        onClick(activePag.current + 1)
                      }
                    >
                      <Link className="page-link" to="#">
                        <i className="la la-angle-right" />
                      </Link>
                      <Link className="paginate_button next" to="#">
                        {" "}
                        Next
                      </Link>
                    </li>
                  </Pagination>
                </div>
              </div>
            </div>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default UsersTable;
